import { lazy } from 'react';

export const LazyLanding = lazy(() => 
  import('@/pages/Landing').then(module => ({ default: module.Landing }))
);
